export const general = {
  " import cen": "Import price",
  "< Wróć": "< Back",
  "Akcje": "Stock",
  "Aktualizuj stany": "Update quantity",
  "Aktywność": "Activity",
  "Aktywny": "Active",
  "Aktywny do": "Active to",
  "Aktywowany": "Activated",
  "Anuluj": "Cancel",
  "Autor": "Author",
  "Baner...": "Banner...",
  "Banery": "Banners",
  "Biodra": "Hips",
  "Biust": "Breast",
  "Brak historii zamówień": "Empty orders history",
  "Brak zdjęcia": "No image",
  "Cancel": "Cancel",
  "Cena": "Price",
  "Cena do": "Max price",
  "Cena docelowa": "Default price",
  "Cena od": "Min price",
  "Cena przed obniżką": "Price before discount",
  "Cena przekreślona": "Original price",
  "Cena przekreślona do": "Max original price",
  "Cena przekreślona od": "Min original price",
  "Cena sprzedaży": "Original price",
  "Cena sprzedaży do": "Max original price",
  "Cena sprzedaży od": "Min original price",
  "Cena wyświetlana": "Price",
  "Cena zakupu": "Purchase price",
  "Cena zakupu do": "Max purchase price",
  "Cena zakupu netto": "Purchase price net",
  "Cena zakupu od": "Purchase price brutto",
  "Ceny produktu": "Products prices",
  "Czas utworzenia": "Creation time",
  "Czy na pewno chcesz usunąć stronę?": "Are you sure you want to delete the page?",
  "Dane do wysyłki": "Shipping information",
  "Dane kontaktowe": "Contact details",
  "Data": "Date",
  "Data aktywacji": "Activated at",
  "Data utworzenia": "Created at",
  "Do daty utworzenia": "Max creation date",
  "Do sztuk": "Max quantity",
  "Dodaj": "Add",
  "Dodaj efekt": "Add effect",
  "Dodaj główną kategorię": "Add a main category",
  "Dodaj kategorię": "Add category",
  "Dodaj kupon": "Add coupon",
  "Dodaj opinię": "Add review",
  "Dodaj produkt": "Add product",
  "Dodaj stronę": "Add page",
  "Dodaj warunki": "Add conditions",
  "Dostawa": "Shipping",
  "Dostępne": "Available",
  "Dostępność w przyszłości": "Availability",
  "Dzieci": "Children",
  "Dzisiejsza": "Set current time",
  "EAN": "EAN",
  "ENTER": "ENTER",
  "Edytuj": "Edit",
  "Edytuj opinię": "Edit review",
  "Edytuj wiele produktów": "Edit many products",
  "Eksportuj ceny produktów": "Export product prices",
  "Element skopiowany do schowka": "Element copied to the clipboard",
  "Followersów": "Followers",
  "Forma wysyłki": "The form of delivery",
  "Gdzie ma przejść po kliknięciu": "Opening target",
  "Grupa produktów": "Products group",
  "Historia": "History",
  "Historia sprzedaży": "Sales history",
  "Historia zamówień": "Orders history",
  "ID": "ID",
  "ID opinii": "Review ID",
  "Ilość": "Quantity",
  "Ilość na stanie": "Quantity",
  "Ilość postów": "Number of posts",
  "Imię": "Name",
  "Importuj ceny": "Import prices",
  "Importuj dane z born2be": "Import data from born2be",
  "Indywidualny numer konta do wpłat": "Individual account number",
  "Informacje o opinii": "Information about the opinion",
  "Instagram": "Instagram",
  "Język": "Language",
  "Język panelu": "Panel language",
  "Język treści": "Content language",
  "Język dynamicznych treści,":"Language of dynamic content",
  "Język tekstów statycznych": "Language of static texts",
  "Kategoria": "Category",
  "Kategorie": "Categories",
  "Kliknij, aby anulować edycję parametrów i modelek": "Click to cancel editing parameters and models",
  "Kliknij, aby edytować kategorie": "Click to edit categories",
  "Kliknij, aby edytować parametry i modelki": "Click to edit parameters and models",
  "Kliknij, aby edytować zdjęcia": "Click to edit images",
  "Kobiety": "Women",
  'Męzczyźni': 'Men',
  "Kod": "Code",
  "Kod Package EAN": "Package EAN",
  "Kod Polski": "SKU",
  "Kod celny": "Tariff code",
  "Kod chiński": "Maker code",
  "Kod polski": "SKU",
  "Kod produktu": "Product code",
  "Kody chińskie": "Maker codes",
  "Kolor": "Color",
  "Komfortu": "Comfort",
  "Koszty wysyłki": "Shipping costs",
  "Kup mniejsze": "Buy smaller",
  "Kup większe": "Buy bigger",
  "Kupony": "Coupons",
  "Kupony - dodaj": "Coupons - add",
  "Lato": "Summer",
  "Liczba mieszkańców": "The number of residents",
  "Liczba postów 12": "Number of posts 12",
  "Liczba postów 24": "Number of posts 24",
  "Liczba postów 36": "Number of posts 36",
  "Liczba postów 48": "Number of posts 48",
  "Liczba postów 60": "Number of posts 60",
  "Liczba znaków": "Number of characters",
  "Lista kategorii": "Categories list",
  "Lista kuponów": "Coupons list",
  "Lista postów": "Posts list",
  "Lista produktów": "Products list",
  "Lista stron": "Static pages list",
  "Losuj": "Random",
  "Marketing": "Marketing",
  "Max Date": "Max Date",
  "Menu": "Menu",
  "Meta keywords": "Meta keywords",
  "Meta description": "Meta description",
  "Miasto": "City",
  "Min Date": "Min Date",
  "Modelki": "Models",
  "Models": "Models",
  "Męski": "Male",
  "Męzczyzni": "Mens",
  "Mężczyzn": "Men",
  'Można łączyć' : 'Can be combined',
  "Następny": "Next",
  "Nazwa": "Name",
  "Nazwa pojedyncza": "Single name",
  "Nazwa produktu": "Product name",
  "Nazwa użytkownika": "User Name",
  "Nazwa wewnętrzna": "Internal name",
  "Nie można łączyć": "Can not be combined",
  "Nieaktywny": "Inactive",
  "Niedostępne": "Not available",
  "Nieunikalny": "Non-unique",
  "Niezaakceptowane": "Not accepted",
  "Niezaakceptowany": "Disapproved",
  "Nijaki": "Neuter",
  "Nijaki mnogi": "Neuter numerous",
  "Notatki": "Notes",
  "Numer strony": "Page no.",
  "O autorze": "About author",
  "OK": "OK",
  "Obniżenie ceny o %": "Price sale by %",
  "Obniżka obecna (%)": "Current sale (%)",
  "Ocena": "Rating",
  "Ocena komfortu": "Comfort rating",
  "Ocena stylu": "Style rating",
  "Od daty utworzenia": "Since creation date",
  'Od najmniejszej' : "Ascending",
  "Od największej": "Descending",
  "Od sztuk": "Min quantity",
  "Odśwież cache": "Refresh cache",
  "Odśwież linki": "Refresh links",
  "Ogólna": "General",
  "Opinie": "Reviews",
  "Opis kategorii": "Description of the category",
  "Opis meta": "Meta description",
  "Opis produktu": "Product description",
  "Otwórz": "Open ",
  "Otwórz wyszukiwarkę": "Show filters",
  "Package EAN (zablokowane)": "Package EAN (blocked)",
  "Parametry": "Parameters",
  "Pełna nazwa": "Full name",
  "Pobierz raport cen produktów": "Download the product price report",
  "Podgląd": "Preview",
  "Podstawowe info": "Basic info",
  "Poprzedni": "Previous",
  "Pora roku": "Season",
  "Połącz w grupę": "Combine into a group",
  "Producent": "Manufacturer",
  "Produkt": "Product",
  "Produkty": "Products",
  "(produktów, kategorii itp)":"(products, coupons, etc.)",
  "Przecena do ( % )": "Sale to (%)",
  "Przecena od ( % )": "Sale from (%)",
  "Przejdź do sklepu": "Go to the store",
  "Przenieś niżej": "Move down",
  "Przenieś wyżej": "Move up",
  "Przypisz": "Assign",
  "Płatność": "Payment",
  "Razem": "Sum",
  "Raporty": "Reports",
  "Raporty cen": "Price reports",
  "Rodzaj nazwy": "Name of the name",
  "Rodzaj przekierowania": "Type of redirection",
  'Rozmiar' : "Size",
  "Rozmiar obuwia": "Size",
  "Rozmiarówka": "Size Chart",
  "Sortowanie": "Sorting",
  'Stan aktywacji':'Activation Status',
  "Status": "Status",
  "Strony statyczne": "Static pages",
  "Strony statyczne - edycja.":"Static pages - edit.",
  "Strony statyczne - nowa.":"Static pages - new.",
  "Stylu": "Style",
  "Submit": "Submit",
  "Suma": "Sum",
  "Szablon": "Template",
  "Szczegóły": "Details",
  "Szczegóły zamówienia": "Order details",
  "Szukaj kategorii...": "Search category...",
  "Słowa kluczowe": "Keywords",
  "Słowo kluczowe": "Keyword",
  "% przeceny": "% Sales",
  "Dodaj warunki wielorabatowe": "Add multi-discount conditions",
  "Tag": "Tag",
  "Talia": "Waist",
  "Total": "Total",
  "Treść": "Content",
  "Treść opinii": "Content of the opinion",
  "Trwa ładowanie": "Loading",
  "Typ": "Type",
  "Typ baneru": "Banner type",
  "Typowa": "Typical",
  "Tytuł": "Title",
  "Tytuł linku": "Link title",
  "Tytuł produktu": "Product title",
  "Typ strony": "Page type",
  'Unikalny' : 'Unique',
  "Upload": "Upload",
  "Ustaw dzisiejszą": "Set today",
  "Usuń": "Delete",
  "Usuń modelkę": "Remove the model",
  "Uwaga": "Warning",
  "Vices status": "Vices status",
  "Voucher": "Voucher",
  "Wartość": "Value",
  "Wartość efektu": "Effect value",
  "Wartość produktów": "Value of products",
  "Ważny do": "Valid until",
  "Ważny od": "Valid since",
  "Wgrywanie zdjęć": "Uploading images",
  "Wiosna/Jesień": "Spring/Autumn",
  "Wpisz alt zdjęcia": "Enter image's alt",
  "Wpisz kod celny": "Enter the customs code",
  "Wpisz link": "Enter the link",
  "Wpisz nazwę": "Enter the name",
  "Wpisz nazwę baneru": "Enter the name of the banner",
  "Wpisz nazwę pojedynczą": "Enter a single name",
  "Wpisz opis kategorii": "Enter the category description",
  "Wpisz opis meta": "Enter the metadescription",
  "Wpisz słowa kluczowe": "Enter keywords",
  "Wprowadź ean": "Enter ean",
  "Wprowadź kod": "Enter code",
  "Wprowadź kody chińskie": "Enter Chinese codes",
  "Wprowadź nazwę": "Enter the name",
  "Wprowadź nazwę produktu": "Enter the product name",
  "Wprowadź nazwę tagu": "Enter the tag",
  "Wprowadź nazwę użytkownika": "Enter the username",
  "Wprowadź tag": "Enter the tag",
  "Wróć": "Back",
  "Wszystkie": "All",
  'Wybierz importowane pola':'Select the imported fields',
  "Wybierz jedno z proponowanych słów kluczowych lub wpisz własne i naciśnij": "Choose one of the suggested keywords or enter your own and press",
  "Wybierz kategorie": "Select categories",
  "Wybierz poniżej...": "Select below...",
  "Wybierz...": "Select ...",
  "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.": "Choosing a given image will immediately send it to our server! Please make sure that the file you are uploading is correct.",
  "Wyczyść filtry": "Clear filters",
  "Wyloguj się": "Log out",
  "Wymiary": "Dimensions",
  "Wyszukaj": "Search",
  "Szukaj": "Search",
  "Wyszukaj po id opinii": "Search by feedback id",
  "Wyszukaj po imieniu": "Search by name",
  "Wyszukaj po kodzie produktu": "Search by product code",
  "Wyszukaj po mieście": "Search by city",
  "Wzrost": "Height",
  "Zamknij": "Close ",
  "Zamknij wyszukiwarkę": "Close filters",
  "Zamówienia": "Orders",
  "Zamówienie numer": "Order number",
  "Zamówienie odrzucone": "Order rejected",
  "Zamówiona ilość": "Ordered quantity",
  "Zapisz": "Save",
  "Zapisz zmiany": "Save changes",
  "Zatwierdź": "Submit",
  "Zaznaczonych produktów": "Selected products",
  "Zdjęcia": "Images",
  "Zdjęcie mobile": "Mobile image",
  "Zdjęcie modelki": "Model image",
  "Zdjęcie na desktop": "Desktop image",
  "Zdjęcie na mobile": "Mobile image",
  "Zima": "Winter",
  "Zmień": "Change",
  "Zmień EAN": "Change EAN",
  "Zmień status": "Change status",
  "Zmień wszędzie": "Change all",
  "Zobacz": "View",
  "Zwiń filtry": "Collapse filters",
  "Rozwiń filtry": "Expand filters",
  "Aktywne": "Active",
  "Nieaktywne": "Inactive",
  "Szybkie filtry": "Quick filters",
  "Do aktywacji": "Ready to activation",
  "Posiada rozmiar": "Has size",
  "Ilość produktów": "Total products",
  "Ładowanie...": "Loading...",
  "Lista zaznaczonych produktów jest pusta": "List of selected products is empty",
  "Czy na pewno chcesz połączyć {{selected}} produktów w jedną grupę?": "Do you really want to merge {{selected}} products into group?",
  "Domyślna": "Default",
  "Eksperymentalna": "Experimental",
  "Data zaimportowania": "Import date",
  "Marża": "Margin",
  "Data modyfikacji": "Modification date",
  "Liczba na stronę": "Items per page",
  "Zaznaczonych wierszy": "Selected rows",
  "Użyj ostatniej akcji": "Use last action",
  "Eksportuj": "Export",
  "Pobierz zdjęcia": "Download images",
  "Ceny": "Prices",
  "Daty": "Dates",
  "Dodaj słowo kluczowe": "Add keyword",
  "Usuń słowo kluczowe": "Delete keyword",
  "Ustaw cenę docelową": "Set default price",
  "Ustaw cenę na cenę docelową": "Set price from default price",
  "Ustaw datę utworzenia": "Set creation date",
  "Ustaw tytuł marketingowy": "Set marketing title",
  "Ustaw opis marketingowy": "Set marketing description",
  "Wybierz akcję": "Select action",
  "Strona główna": "Homepage",
  "Strona główna aplikacji": "Application homepage",
  "Ostatnie pary": "Last pairs",
  'Klienci': "Clients",
  'Usuwanie': 'Deleting',
  'Sposoby dostawy': 'Shipment methods',
  'Zarządzanie aktywnością': 'Manage activity',
  'Historia zmian': 'Changes log',
  'Konfiguracje': 'Configurations',
  'Linki': 'Links',
  'Dashboard': 'Dashboard',
  'Wybierz język.': 'Choose language.',
  'Sortuj': 'Sort',
  'malejąco': 'descending',
  'Brak': 'Not set',
  'Informacje ogólne': 'General info',
  'Użytkownik': 'User',
  'Kupon': "Coupon",
  "Poprzednia": "Previous",
  "Następna": "Next",
  "Top menu": "Top menu",
  "Menu mobilne": "Mobile RWD menu",
  "Menu w stópce": "Footer menu",
  "Menu mobilne APP": "Mobile APP menu",
  "Menu mobilne APP (v4)": "Mobile APP menu (v4)",
  "Tak": "Yes",
  "Nie": "No",
  "Nieznany": "Unknown",
  "Ok": "Ok",
  "Mężczyźni": "Men",
  "np.": "e.g.",
  'Cache został odświeżony': "Cache has been refreshed",
  "Id": "Id",
  "Typ zmiany": "Change type",
  "Szczegóły edycji": "Change's details",
  "Wyszukaj po mailu użytkownika": "Search by user email",
  "Od dnia": "Min date",
  "Do dnia": "Max date",
  "Pozycja": "Position",
  "lub": "or",
  "Wchodząc w ten link stracisz wszystkie niezapisane zmiany. Czy chcesz kontynuować?": "Entering this link will cause lost of all unsaved changes. Do you want to continue?",
  "Kompresja JPG": "JPG compression",
  "Wprowadziliśmy wymaganą kompresję plików JPG - zostaną one skompresowane do {{level}}%. Może to skutkować różnymi artefaktami na zdjęciach baneru": "We have implemented compression of jpg files  - they will be compressed to {{level}}%. It might cause some artifacts on images",
  "W tej samej karcie": "In the same tab",
  "W nowej karcie": "In new tab",
  "Szukaj po nazwie": "Search by name",
  "Ustaw datę": "Set date",
  "Ustaw czas": "Set time",
  "Data jest nieprawidłowa": "Provided date is invalid",
  "aktywny": "active",
  "nieaktywny": "inactive",
  "Czy chcesz usunąć tą stronę?": "Do you want to delete this page?",
  "Strona została usunięta": "Page has been deleted",
  "Aktywna od": "Active since",
  "Aktywna do": "Active until",
  "Strona domowa Neutralna": "Homepage - neutral",
  "Strona domowa Kobiety": "Homepage - woman",
  "Strona domowa Mężczyźni": "Homepage - man",
  "Strona domowa Dzieci": "Homepage - children",
  "O nas": "About us",
  "FAQ": "FAQ",
  "Polityka prywatności": "Private policy",
  "Darmowa dostawa": "Free shipping",
  "Informacje o wysyłce wewnątrz kraju": "Informations about domestic shipping",
  "Informacje o zwrotach": "Informations about returns",
  "Metody płatności": "Payment methods",
  "Wybór rozmiaru": "Size choosing",
  "Newsletter": "Newsletter",
  "Blogerki": "Blogers",
  "Współpraca": "Collaboration",
  "Promocje": "Promotions",
  "Regulamin sklepu": "Store rules",
  "Regulamin promocji": "Promotions rules",
  "Regulamin zwrotów": "Returns rules",
  "Informacja o przetwarzaniu danych osobowych": "Personal data protection",
  "Kody rabatowe": "Coupons",
  "Regulamin konkursów": "Contests rules",
  "Wproadź tytuł": "Enter title",
  "Wprowadź tytuł strony (SEO)": "Enter title (SEO)",
  "Tytuł strony (SEO)": "Title (SEO)",
  "Wprowadź treść": "Enter content",
  "Edycja strony powiodła się.": "Successfully edited this page.",
  "Strona została dodana.": "New page has been added successfully.",
  "Dodaj stronę do pomocnych linków": "Add to favorite places",
  "Link został dodany": "Link has been added",
  "Uzupełnij wszystkie pola poprawnie": "Please fill all inputs with valid data",
  "Pomocne linki": "Favorite links",
  "Link został usunięty": "Link has been deleted.",
  "Email użytkownika": "User's email",
  "Znajdź użytkownika": "Find user",
  "Program lojalnościowy": "Loyalty program",
  "Zarządzanie zgodami": "Manage agreements",
  "dni temu": "days ago",
  "Udało się": "Success",
  "Brak zmian": "No changes",
};



// WEBPACK FOOTER //
// ./locales/en_US/general.js